import Vue from 'vue'

/**
 * @author jorge nuñez lópez <>
 *
 * Create a new requisition material from warehouse 
 * @param payload New entry object
 * @return {object}
 */

function dataTransformer({
  supply, quantity, unitPrice, comment
}) {
  return {
    supply,
    quantity: +quantity,
    unit_price: +unitPrice,
    comment
  }
}
export default (generalComment, newRm, warehouseId) => {
  const payload = {
    supplies: newRm.map(dataTransformer),
    comment: generalComment ? generalComment : ''
  } 
  return Vue.$http.post(`iwarehouse/${warehouseId}/requisition/create/without-quatification/`, payload)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/createRmFromWarehouse.js